import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLine } from "./Reveal";
import { scrollToId } from "../../lib/scroll";
import { ArrowDown } from "lucide-react";

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const imgScale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);
  const textY = useTransform(scrollYProgress, [0, 1], ["0%", "-40%"]);

  const scrollToMenu = () => scrollToId("#menu");

  return (
    <section ref={ref} data-testid="hero-section" className="relative min-h-[100svh] pt-28 md:pt-32 pb-16 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div style={{ y: textY }} className="relative z-20">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9, duration: 1 }}
            className="text-xs tracking-[0.3em] uppercase font-medium text-[#B07D4E] mb-6 md:mb-8"
          >
            Premium Bakery · Built for Service
          </motion.p>

          <h1 className="font-display font-500 text-[#2A221C] text-[15vw] leading-[0.86] md:text-[10vw] lg:text-[9rem] tracking-tight">
            <MaskLine delay={0.15}>Handcrafted</MaskLine>
            <MaskLine delay={0.3} className="italic text-[#D4A373]">indulgence,</MaskLine>
            <MaskLine delay={0.45}>at scale.</MaskLine>
          </h1>
        </motion.div>

        <div className="mt-8 md:mt-0 md:absolute md:right-10 md:top-40 md:w-[46vw] lg:w-[42vw] z-10">
          <div className="relative overflow-hidden rounded-sm border border-[#E6E2D8] aspect-[4/5] md:aspect-[3/4]">
            <motion.img
              src="/products/hero.jpg"
              alt="Assortment of Artisan Bites desserts"
              style={{ y: imgY, scale: imgScale }}
              initial={{ scale: 1.15, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 1.6, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 1 }}
          className="relative z-20 mt-10 md:mt-24 max-w-md"
        >
          <p className="font-body text-base sm:text-lg leading-relaxed font-light text-[#2A221C]/80">
            Signature desserts, cookies and bakes — developed for hotels, restaurants
            and cafés. Freezer-to-plate simplicity, pastry-chef finish.
          </p>
          <button
            data-testid="hero-explore-btn"
            onClick={scrollToMenu}
            className="group mt-8 inline-flex items-center gap-3 text-xs tracking-[0.2em] uppercase font-medium text-[#2A221C]"
          >
            <span className="h-11 w-11 rounded-full border border-[#2A221C] flex items-center justify-center group-hover:bg-[#D4A373] group-hover:border-[#D4A373] transition-colors">
              <ArrowDown className="h-4 w-4 group-hover:text-white transition-colors" />
            </span>
            Explore the menu
          </button>
        </motion.div>
      </div>
    </section>
  );
};
